import { formatInTimeZone } from 'date-fns-tz'
import { APP_TIME_ZONE, type DayKey } from './time'

/** 1:04:09 while running — always tabular, never jittering. */
export function formatElapsed(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000))
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  const mm = m < 10 ? `0${m}` : String(m)
  const ss = s < 10 ? `0${s}` : String(s)
  return h > 0 ? `${h}:${mm}:${ss}` : `${m}:${ss}`
}

/** 2h 05m — for totals, where seconds are noise. */
export function formatDuration(ms: number): string {
  const minutes = Math.round(ms / 60000)
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return `${m}m`
  return `${h}h ${m < 10 ? `0${m}` : m}m`
}

export function formatClock(instant: Date, timeZone: string = APP_TIME_ZONE): string {
  return formatInTimeZone(instant, timeZone, 'HH:mm')
}

export function formatDayLabel(key: DayKey, pattern = 'EEE d MMM'): string {
  const [y, m, d] = key.split('-').map(Number)
  return formatInTimeZone(new Date(Date.UTC(y ?? 1970, (m ?? 1) - 1, d ?? 1, 12)), 'UTC', pattern)
}
